/* eslint-disable */
import ko from 'knockout';
import humanize from '@bingads-webui-component-legacy/humanize/byte';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!uet');
export default function (model) {
  this.statusText = ko.observable(model.statusText);
  this.showProgress = ko.observable(model.showProgress);
  this.completed = ko.observable(model.completed);
  this.total = ko.observable(model.total);
  this.progressDetails = ko.computed((function () {
    if (model.type === 'Upload') {
      return i18n.getString('UnifiedEventTracking_UploadConversions_UploadProgress_Details', humanize.fileSize(this.completed()), humanize.fileSize(this.total()));
    } else {
      return i18n.getString('UnifiedEventTracking_UploadConversions_TaskProgress_Details', this.completed(), this.total());
    }
  }).bind(this));
  this.percentage = ko.computed((function () {
    return (this.total() === 0 ? 0 : this.completed() / this.total()) * 100 + '%';
  }).bind(this));
}

